import {
    List,
    DayBook,
    MyBillDetails,
    MonthlyBill,
    MonthlySummaryBill,
    ChitBill,
    Stock,
    TransanctionDetails,
    MonthlySalePurchase,
    ItemRevenue,
    ProductionCost,
    ProductionCostDetails,
    LedgerDetails,
    GroupLedger,
    Groups,
    OfficerBill,
    MonthlyLedger,
    AuditLedgerDetails,
    PrepareBill,
    RejectedChitBill,
    PreSanctionDetails
} from "../Components";

export default [
    { path: "/store/report/today-member", component: List, name: "report-store-today-members" },
    { path: "/store/report/day-book", component: DayBook, name: "report.store.daybook" },
    { path: "/store/report/day-book-removed", component: DayBook, name: "report.store.daybook.removed" },
    { path: "/store/report/chit-bill", component: ChitBill, name: "report.store.chit.bill" },
    {
        path: "/store/report/rejected-chit-bill",
        component: RejectedChitBill,
        name: "report.store.rejected.chit.bill"
    },
    { path: "/store/report/daily-messing", component: DayBook, name: "voucher.store.messing.view" },
    { path: "/store/report/my-monthly-bill", component: MyBillDetails, name: "report.store.my.bill" },
    { path: "/store/report/monthly-bill", component: MonthlyBill, name: "report.store.monthly.bill" },
    // { path: '/store/report/monthly-summary-bill', component: MonthlySummaryBill, name: 'report.store.daining.summary.bill' },
    { path: "/store/report/monthly-summary-bill", component: MonthlySummaryBill, name: "report.store.monthly.summary.bill" },

    { path: "/store/report/officer-bill", component: OfficerBill, name: "report.store.officer.bill" },
    { path: "/store/report/bill", component: PrepareBill, name: "report.store.prepare.bill" },
    // { path: '/store/report/company-wise-bill', component: CompanyWiseBill, name: 'report.canteen.company.bill' },

    { path: "/store/report/stock", component: Stock, name: "report.store.inventory.stock" },
    { path: "/store/report/item-voucher-details", component: TransanctionDetails, name: "report.store.product.transanction.details" },
    { path: "/store/report/monthly-sales-purchase-profit", component: MonthlySalePurchase, name: "report.store.sales.purchase" },
    { path: "/store/report/monthly/sale-purchase", component: ItemRevenue, name: "report.store.item.revinue.monthly" },

    { path: "/store/report/production-cost", component: ProductionCost, name: "report.store.production" },
    { path: "/store/report/production-cost/:id", component: ProductionCostDetails, name: "report.store.production.details" },

    // { path: '/store/report/item-voucher-details', component: ItemsVoucherDetails, name: 'report.store.product.voucher.details' },
    { path: "/store/report/ledger", component: LedgerDetails, name: "report.store.LedgerDetails" },
    { path: "/store/report/ledger/:id", component: GroupLedger, name: "report.store.ledger" },
    { path: "/store/report/monthly-ledger/:id", component: MonthlyLedger, name: "report.store.monthly.ledger" },
    // { path: '/store/report/ledger-items', component: LedgerItemsDetails, name: 'report.store.LedgerItemDetails' },
    // {
    //     path: '/store/report/ledger-details',
    //     component: LedgerTransactionDetails,
    //     name: 'report.store.LedgerTranDetails'
    // },

    //Account Group
    { path: "/store/report/group", component: Groups, name: "report.store.group" },
    { path: "/store/report/group/:id", component: GroupLedger, name: "report.store.group.ledger" },
    // { path: '/store/report/group-emi', component: LedgerEMIDetails, name: 'report.store.group.ledger.emi' },

    { path: "/rstore/eports/audit-ledger", component: AuditLedgerDetails, name: "report.store.audit-ledger" },

    {
        path: "/reports/pre-sanction/details/:id",
        component: PreSanctionDetails,
        name: "report.store.presanction.details"
    }
];
